import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import createSagaMiddleware from 'redux-saga'
import makeRootReducer from './reducers'
import api from 'middleware/api'
import persistState from 'redux-localstorage'
import { isLocalStorageNameSupported } from 'utils/detector'

export default (initialState = {}, history, persistStateConfig = null) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const sagaMiddleware = createSagaMiddleware()
  const middleware = [api, sagaMiddleware, routerMiddleware(history)]

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = []

  // add localStorage enhancer, but only if it's supported by the browser (i.e. iPad incognito/private sessions will crash upon attempting to use localstorage)
  if (persistStateConfig && isLocalStorageNameSupported()) {
    enhancers.push(
      persistState(null, persistStateConfig)
    )
  }
  if (__DEBUG__) {
    const devToolsExtension = window.devToolsExtension
    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension())
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    initialState,
    compose(
      applyMiddleware(...middleware),
      ...enhancers
    )
  )
  store.asyncReducers = {}
  store.asyncSagas = {}
  store.runSaga = (saga) => {
    sagaMiddleware.run(saga)
  }

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  return store
}



/** WEBPACK FOOTER **
 ** ./src/store/createStore.js
 **/